<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2024-05-24 09:40:24
 * @LastEditTime : 2024-05-24 14:06:07
 * @LastEditors  : yangxr
 * @Description  : 质量模板设置
 * @FilePath     : \icps_fb\src\views\platform\ICPS\basicConfig\components\templateSet.vue
-->
<template>
  <div>
    <el-dialog :visible.sync="visible" width="960px" :close-on-click-modal="false" :append-to-body="true" :before-close="resetFromData" @open="open">
      <span slot="title" class="dialog-title"> 检验模版设置 </span>
      <div>
        <div style="position: relative; margin-bottom: 10px;height: 30px;">
          <div style="position: absolute; left: 10px; top: 0">
            <el-button size="mini" class="bottom_all but1" style="margin-left: 10px" @click="addItem()">添 加</el-button>
          </div>
        </div>
        <el-table ref="multipleTable" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="tableData" tooltip-effect="dark">
          <el-table-column label="原物料名称" align="center" prop="name" :min-width="160">
            <template slot-scope="scope">
              <el-select v-model="scope.row.rawId" filterable placeholder="请选择">
                <el-option v-for="(item, index) in rawList" :key="index" :label="item.name" :value="item.id" @click.native="scope.row.rawName = item.name"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="检验模板" align="center" prop="brand" :min-width="140">
            <template slot-scope="scope"
              ><el-select v-model="scope.row.templeId" filterable placeholder="请选择">
                <el-option v-for="(item, index) in templateList" :key="index" :label="item.name" :value="item.id+''" @click.native="scope.row.templeName = item.name"></el-option> </el-select
            ></template>
          </el-table-column>
          <el-table-column label="操作" align="center" prop="manufacturer" :min-width="140">
            <template slot-scope="scope">
              <el-button class="bottom_one" size="mini" @click="saveFromData(scope.row)">保存</el-button><el-button class="bottom_two" size="mini" @click="deleteData(scope.row, scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetFromData">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
import { queryVerifyTemplates, saveVerifyTemplates, deleteVerifyTemplates } from "@/api/basicConfig/CPYquality.js";
export default {
  data() {
    return {
      tableParam: {
        companyId: "",
      },
      tableData: [],
      templateList: [
        {
          name: "水泥",
          id: 1,
        },
        {
          name: "粉煤灰",
          id: 2,
        },
        {
          name: "矿粉",
          id: 3,
        },
        {
          name: "复合掺合料",
          id: 4,
        },
        {
          name: "砂",
          id: 5,
        },
        {
          name: "碎石",
          id: 6,
        },
        {
          name: "泵送剂",
          id: 7,
        },
        {
          name: "膨胀剂",
          id: 8,
        },
        {
          name: "硅灰",
          id: 9,
        },
        {
          name: "聚丙烯纤维",
          id: 10,
        },
      ],
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    rawList: {
      type: Array,
      default: () => [],
    },
    companyId: {
      type: String,
      default: "",
    },
    companyName: {
      type: String,
      default: "",
    },
  },
  watch: {},
  async created() {},
  methods: {
    addItem() {
      let obj = {
        id:"",
        rawId: "", //原物料id
        rawName: "", //原物料名称
        templeId: "", //模版id
        templeName: "", //模版名称
        companyId: this.companyId, //公司
        companyName: this.companyName, //
      };
      this.tableData.push(obj);
    },
    open() {
      this.tableParam.companyId = this.companyId;
      this.queryVerifyTemplates();
    },
    queryVerifyTemplates() {
      queryVerifyTemplates({ ...this.tableParam }).then(res => {
        if (res.code === 1001) {
          this.tableData = res.data;
        }
      });
    },

    resetFromData() {
      this.$emit("update", false);
    },
    /*保存/修改弹窗*/
    saveFromData(row) {
      let params = row;
      console.log(row)
      if (!params.rawId || !params.templeId) {
        this.$message.warning("原物料和模板不能为空");
        return;
      }
      saveVerifyTemplates( params ).then(res => {
        if (res.code == 1001) {
          this.$message.success("保存成功!");
          this.queryVerifyTemplates();
        }
      });
    },
    //删除
    deleteData(row, index) {
      if (row.id) {
        this.$confirm("确定删除该数据?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          cancelButtonClass: "bottom_all_two",
          confirmButtonClass: "bottom_all",
          type: "warning",
        })
          .then(() => {
            const params = {
              id: row.id,
            };
            deleteVerifyTemplates(params).then(res => {
              if (res.code === 1001) {
                this.$message.success("删除成功");
                this.queryVerifyTemplates();
              }
            });
          })
          .catch(() => {});
      } else {
        this.tableData.splice(index, 1);
      }
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.title_box {
  display: block;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 22px;
  color: #000000;
  margin-bottom: 10px;
}
.el-form-item__label {
  color: #000000;
  font-size: 14px;
}
.table_link {
  margin-left: 10px;
  color: $bg_color;
}
.table_link:hover {
  opacity: 0.8;
}
</style>
  